/*
 * Tooltip
 * @module components
 * @flow
 */

import React from 'react';
import RCTooltip from 'rc-tooltip';

import 'rc-tooltip/assets/bootstrap.css';

export type TooltipProps = {
  children?: React$Node,
  container?: string,
};

/**
 * Tooltip React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {React.Children} [props.children] - childs
 * @param {string} [props.container] - container
 * @example <caption>Simple usage</caption>
 * <Tooltip placement="left" overlay="text">Text</Tooltip>
 * @returns {React.Node<*>} React-component
 */
export const Tooltip = ({ children, container, ...rest }: TooltipProps) => (
  <RCTooltip
    mouseEnterDelay={0}
    mouseLeaveDelay={0.1}
    arrowContent={<div className="rc-tooltip-arrow-inner" />}
    destroyTooltipOnHide
    overlayClassName="react-tooltip"
    // $FlowIssue
    getTooltipContainer={() => document.querySelector(container)}
    trigger={['hover']}
    {...rest}
  >
    {children}
  </RCTooltip>
);

Tooltip.defaultProps = {
  container: 'body',
};
